import { render, staticRenderFns } from "./DonutChart22.vue?vue&type=template&id=e36fc500&scoped=true&"
import script from "./DonutChart22.vue?vue&type=script&lang=js&"
export * from "./DonutChart22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36fc500",
  null
  
)

export default component.exports